interface MFModule {
  [module: string]: {
    name: string;
    entry: {
      local: string;
      dev: string;
      qa: string;
      beta: string;
      prod: string;
    };
    modules: string[];
  };
}

export const MF_MODULES: MFModule = {
  widgets: {
    name: 'widgets',
    entry: {
      local: 'http://localhost:8081/remoteEntry.js',
      dev: 'https://assets.lightmetrics.co/mf/widgets/dev/latest/remoteEntry.js',
      qa: 'https://assets.lightmetrics.co/mf/widgets/qa/latest/remoteEntry.js',
      beta: 'https://assets.lightmetrics.co/mf/widgets/beta/latest/remoteEntry.js',
      prod: 'https://assets.lightmetrics.co/mf/widgets/prod/v0.0.1/remoteEntry.js',
    },
    modules: ['./TestWidget', './MarketingEmailBanner'],
  },
  home: {
    name: 'home',
    entry: {
      local: 'http://localhost:8082/remoteEntry.js',
      dev: 'https://assets.lightmetrics.co/mf/home/dev/latest/remoteEntry.js',
      qa: 'https://assets.lightmetrics.co/mf/home/qa/latest/remoteEntry.js',
      beta: 'https://assets.lightmetrics.co/mf/home/beta/latest/remoteEntry.js',
      prod: 'https://assets.lightmetrics.co/mf/home/prod/v1.1.1/remoteEntry.js',
    },
    modules: ['./Home', './ThumbnailCard'],
  },
  incidentModal: {
    name: 'incidentModal',
    entry: {
      local: 'http://localhost:8080/remoteEntry.js',
      dev: 'https://assets.lightmetrics.co/mf/incidentModal/dev/latest/remoteEntry.js',
      qa: 'https://assets.lightmetrics.co/mf/incidentModal/qa/latest/remoteEntry.js',
      beta: 'https://assets.lightmetrics.co/mf/incidentModal/beta/latest/remoteEntry.js',
      prod: 'https://assets.lightmetrics.co/mf/incidentModal/prod/v0.0.1/remoteEntry.js',
    },
    modules: ['./EventModal'],
  },
  SafetyEvents: {
    name: 'SafetyEvents',
    entry: {
      local: 'http://localhost:8085/remoteEntry.js',
      dev: 'https://assets.lightmetrics.co/mf/SafetyEvents/dev/latest/remoteEntry.js',
      qa: 'https://assets.lightmetrics.co/mf/SafetyEvents/qa/latest/remoteEntry.js',
      beta: 'https://assets.lightmetrics.co/mf/SafetyEvents/beta/latest/remoteEntry.js',
      prod: 'https://assets.lightmetrics.co/mf/SafetyEvents/prod/v0.0.1/remoteEntry.js',
    },
    modules: ['./SafetyEvents', './DateComponent', './TagComponent'],
  },
  configurations: {
    name: 'configurations',
    entry: {
      local: 'http://localhost:8087/remoteEntry.js',
      dev: 'https://assets.lightmetrics.co/mf/configurations/dev/latest/remoteEntry.js',
      qa: 'https://assets.lightmetrics.co/mf/configurations/qa/latest/remoteEntry.js',
      beta: 'https://assets.lightmetrics.co/mf/configurations/beta/latest/remoteEntry.js',
      prod: 'https://assets.lightmetrics.co/mf/configurations/prod/v0.1.0/remoteEntry.js',
    },
    modules: ['./configurations'],
  },
};
